// extracted by mini-css-extract-plugin
export default {"title":"styles_title__88DCT","row":"styles_row__f5z9B","copyButton":"styles_copyButton__e33gx"};